<template>
    <section :class="$style.container">
        <h1 :class="$style.headline">{{$t('headlines.success_payment_without_token_headline')}}</h1>
        <h2 :class="$style.title">{{$t('headlines.success_payment_without_token_text')}}</h2>
    </section>
</template>

<style module type="postcss">
    .container {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .headline {
        font-size: 36px;
        font-weight: 500;
        margin: 0;
    }

    .title {
        font-size: 24px;
        font-weight: 500;
        margin: 54px 0 0 0;
    }
</style>

<script>
    export default {
        name: 'NotificationPaymentSuccess'
    }
</script>
